<template>
  <Teleport :disabled="screenMinSm || !hasTeleportTarget" :to="teleportTarget">
    <Button class="back-button" variant="ghost" :size="'large'" @click="emit('back-nav')">
      <Icon name="chevron-left" />
      <span>{{ screenMinSm ? desktopBackTitle : 'Back' }}</span>
    </Button>
  </Teleport>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref } from 'vue';

import { screenMinSm } from '../utils/tallo-breakpoints.util';
import Button from './button/button.vue';
import Icon from './icon.vue';

const emit = defineEmits(['back-nav']);

const props = withDefaults(
  defineProps<{
    /**
     * Id of an element outside this page (e.g. the app header) that hosts the button on small screens.
     * Rendered inline when omitted or when no such element exists in the document.
     */
    teleportSlotId?: string;
    desktopBackTitle?: string;
  }>(),
  {
    desktopBackTitle: 'Back',
  },
);

// Vue never mounts Teleport children whose target is missing and then throws while unmounting them
// (vuejs/core#4075), which leaves the surrounding router view unable to render anything else.
// Resolve the slot once, right before the Teleport mounts, and stay inline when it is absent.
const hasTeleportTarget = ref(false);
const teleportTarget = computed(() => (props.teleportSlotId ? `#${props.teleportSlotId}` : 'body'));

onBeforeMount(() => {
  hasTeleportTarget.value = Boolean(props.teleportSlotId && document.getElementById(props.teleportSlotId));
});
</script>

<style scoped lang="scss">
.back-button.back-button {
  width: fit-content;
  padding-left: 0;
}
</style>
